<template>
  <div>
    <input type="hidden" name="_token" :value="csrf" />
    <input v-if="this.editing" type="hidden" name="_method" value="PUT" />
    <div v-if="this.limitMin > 0 || this.limitMax > 0" class="alert alert-warning" role="alert">
      <p v-if="this.limitMin > 0">{{ __("forms.EvaluationChart.questions.questions_setting.question10.limitMinRequired") }} {{ limitMin }}</p>
      <p v-if="this.limitMax > 0">{{ __('forms.EvaluationChart.questions.questions_setting.question10.limitMaxRequired') }} {{ limitMax }}</p>
    </div>
    <div class="form-group row d-flex ml-1" v-if="canModify >= 2">
      <div>
        <label class="text-voice-title">
          {{ __("misc.filterBy") }}:
        </label>
        <select class="form-control" v-model="advancedFilterMethod" @change="getSelectOptionsData()">
          <option value="">---</option>
          <option value="keyWords">
            {{ __('forms.Courses.course') }}
          </option>
          <option value="category">
            {{ __('forms.Course.categories') }}
          </option>
          <option value="catalogCategory">
            {{ __('forms.Course.catalogCategories') }}
          </option>
          <option value="place">
            {{ __('forms.Courses.place') }}
          </option>
          <option value="duration">
            {{ __('forms.Courses.duration') }}
          </option>
          <option value="deliveryMethod">
            {{ __('forms.Course.deliveryMethod') }}
          </option>
          <option value="trainingAgency">
            {{ __('forms.Courses.trainingAgency') }}
          </option>
          <option value="begin_date">
            {{ __('forms.Courses.started_at') }}
          </option>
          <option value="end_date">
            {{ __('forms.Courses.ended_at') }}
          </option>
        </select>
      </div>
      <div class="ml-3 mr-3">
        <label>

        </label>
        <div class=" " v-if="advancedFilterMethod == 'category' ||
        advancedFilterMethod == 'catalogCategory' ||
          advancedFilterMethod == 'place' ||
          advancedFilterMethod == 'trainingAgency' ||
          advancedFilterMethod == 'deliveryMethod'">
          <select class="form-control" v-model="advancedFilterDropdownSelect">
            <option value="">...</option>
            <option v-for="row in advancedFilterDropdownData" :key="row.id" :value="row.id">
              {{ row.name }}
            </option>
          </select>
        </div>
        <div class=" " v-else-if="advancedFilterMethod == 'keyWords'">
          <input v-model="searchBar" type="text" class="form-control">
        </div>
        <div class=" " v-else-if="advancedFilterMethod == 'duration'">
          <input v-model="advancedFilterNumber" type="number" class="form-control">
        </div>
        <div class=" " v-else-if="advancedFilterMethod == 'begin_date' || advancedFilterMethod == 'end_date'">
          <input v-model="advancedFilterDate" type="date" class="form-control">
        </div>
      </div>
      <div>
        <a data-toggle="tooltip" data-placement="top" :title="__('views.Learning.questionLearning.search_ask_course')"
          class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history mr-2 mt-4"
          @click="searchCourses">
          <i class="fas fa-search"></i>
        </a>
      </div>
      <div>
        <a data-toggle="tooltip" data-placement="top" :title="__('views.Learning.questionLearning.show_all_courses')"
          v-if="tableSearch.length == 0"
          class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history mr-2 mt-4"
          @click="searchAllCourses">
          <i class="fas fa-book"></i>
        </a>

        <a data-toggle="tooltip" data-placement="top" :title="__('misc.close')" v-else
          class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history mr-2 mt-4"
          @click="tableSearch = []">
          <i class="fas fa-times"></i>
        </a>
      </div>
      <div class="mt-4 ml-2" v-if="showLoader">
        <i class="fa-solid fa-2x fa-sync fa-spin colored-icon"></i>
      </div>
    </div>
    <div style="padding-left:15px; padding-right:15px" class="row">
      <div class="col-8 learningSearchRequest" v-if="canModify >= 2">
        <h6 class="text-primary h6 mt-4 ml-1">
          {{ __("views.Learning.questionLearning.results_search") }}
        </h6>
        <div style="overflow: scroll; max-height: 400px">
          <table class="table tableFixHead">
            <thead class="skills-table-head">
              <tr>
                <th style="width: 40px; max-width: 40px"></th>
                <th class="skills-table-head-title">{{ __("views.Learning.questionLearning.request") }}</th>
                <th class="skills-table-head-title">{{ __("views.campaignsToApprove.details") }}</th>
                <th class="skills-table-head-title">{{ __("views.Learning.questionLearning.typology") }}</th>
                <th class="skills-table-head-title">{{ __("forms.Course.delivery") }}</th>
                <th class="skills-table-head-title">{{ __("forms.Course.duration") }}</th>
                <th class="skills-table-head-title">{{ __("forms.Course.trainingAgency") }}</th>
                <th class="skills-table-head-title">{{ __("views.Learning.questionLearning.categories") }}</th>
              </tr>
            </thead>
            <tbody v-if="!empty_values">
              <tr v-for="course in this.tableSearch" class="icon-button" :key="course.id">
                <td class="icon-button" style="width: 40px; max-width: 40px">
                  <a class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit"
                    @click="addSearchRow(course.id, course.typology, course.name)">
                    <i class="fas fa-plus"></i>
                  </a>
                </td>
                <td>{{ course.name }}</td>
                <td class="icon-button">
                  <a href="#" @click="openCourseInfo(course.info)"
                    class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history">
                    <i class="fas fa-info"></i>
                  </a>
                </td>
                <td>{{ course.typologyName }}</td>
                <td>{{ course.delivery }}</td>
                <td>{{ course.duration }}</td>
                <td>{{ course.agency }}</td>
                <td>{{ course.categories }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="!empty_values && canModify >= 1" class="col-4">
        <h6 class="text-primary h6 mt-4 ml-1">
          {{ __("views.Learning.questionLearning.corsi_selezionati") }}
        </h6>
        <table class="table tableFixHead" style="overflow: hidden">
          <thead class="skills-table-head">
            <tr>
              <th style="width: 40px; max-width: 40px" v-if="canModify >= 2"></th>
              <th class="skills-table-head-title"> {{ __("views.Learning.questionLearning.request") }}</th>
              <th class="skills-table-head-title">{{ __("views.Learning.questionLearning.info") }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(request, index) in this.tableRequest" :key="'tablerequest_' + index">
              <td class="icon-button" style="width: 40px; max-width: 40px" v-if="canModify >= 2">
                <a class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove hrt-button"
                  @click="rmRequestRow(request, index)">
                  <i class="fas fa-trash"> </i>
                </a>
              </td>
              <td>{{ request.request }}</td>
              <td class="icon-button">
                <a v-if="request.infoUrl !== undefined" href="#" @click="openCourseInfo(request.infoUrl)"
                  class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history">
                  <i class="fas fa-info-circle"></i>
                </a>
              </td>
              <!-- Campi hidden per salvataggio nella sessione -->
              <div v-if="saving_settings == 'save_on_evaluation_chart'">
                <input type="hidden" :name="'question[' +
                  question_survey_id +
                  '][trainingNeeds][' +
                  index +
                  '][id]'
                  " :value="request.id" />
                <input type="hidden" :name="'question[' +
                  question_survey_id +
                  '][trainingNeeds][' +
                  index +
                  '][training_need_id]'
                  " :value="request.training_need_id" />
                <input type="hidden" :name="'question[' +
                  question_survey_id +
                  '][trainingNeeds][' +
                  index +
                  '][typology_id]'
                  " :value="request.typology_id" />
                <input type="hidden" :name="'question[' +
                  question_survey_id +
                  '][trainingNeeds][' +
                  index +
                  '][request]'
                  " :value="request.request" />
                <input type="hidden" :name="'question[' +
                  question_survey_id +
                  '][trainingNeeds][' +
                  index +
                  '][applicant_person_id]'
                  " :value="request.applicant_person_id" />
              </div>
            </tr>
            <tr v-if="saving_settings === 'save_on_evaluation_chart' && tableRequest.length === 0">
              <input type="hidden" :name="'question[' + question_survey_id + '][trainingNeeds][' + 0 + '][id]'"
                :value="-1" />
            </tr>

            <div v-for="(deletedItem, index) in this
              .deletedExistingTrainingRequest" :key="index">
              <input type="hidden" :name="'question[' + question_survey_id + '][deletedItems][]'" :value="deletedItem" />
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<style>

  .skills-table-head-title {
    color: #1767A2 !important;
    font-weight: 800 !important;
  }
</style>
<script>
export default {
  mounted() {
    this.populateRequestTable();
    this.canModify = this.permission_request;
  },
  props: {
    is_admin: {
      type: Number,
      required: true,
    },
    permission_request: {
      type: Number,
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    compiler_person_id: {
      type: Number,
      required: true,
    },
    owner_person_id: {
      type: Number,
      required: true,
    },
    free_request: {
      type: Boolean,
      required: true,
    },
    catalogs_search: {
      type: [Object, Array],
      required: true,
    },
    training_plans_search: {
      type: [Object, Array],
      required: true,
    },
    search_in_training_plans: {
      type: Number,
      required: true,
    },
    search_in_catalogs: {
      type: Number,
      required: true,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
    saving_settings: {
      type: String,
      required: true,
    },
    answers_question: {
      type: Object,
      required: false,
    },

    labels: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

      userUrl: this.is_admin ? "" : "-user",

      searchCatalog: null,
      tableSearch: [],
      deletedExistingTrainingRequest: [],
      tableRequest: [],
      canModify: null,
      showLoader: false,
      limitMin: null,
      limitMax: null,
      numberOfCourses: 0,
      //
      advancedFilterMethod: null,
      advancedFilterDropdownData: {},
      searchBar: "",
      advancedFilterDropdownSelect: null,
      advancedFilterNumber: null,
      advancedFilterDate: null,
      //default
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  methods: {
    openCourseInfo(url) {
      app.__vue__.$refs.vue_popup.toggle(this.__("views.Learning.questionLearning.info"), url);
    },
    getSelectOptionsData() {
      this.advancedFilterDropdownData = {};

      if (this.advancedFilterMethod == '' || this.advancedFilterDropdownSelect == '' ||
        ['keyWords', 'duration', 'begin_date', 'end_date'].includes(this.advancedFilterMethod)) {
        return;
      }
      this.showLoader = true;
      axios
        .get("/learning-request-question-select-options" + "/" + this.advancedFilterMethod)
        .then((response) => {
          this.advancedFilterDropdownData = response.data;
          this.showLoader = false;
        });
    },
    addSearchRow(training_need_id, typology, request) {
      this.addSRequest(training_need_id, typology, request);
    },
    addSRequest(training_need_id, typology, request) {
      if(this.numberOfCourses + 1 > this.limitMax && this.limitMax != 0) {
        return Vue.swal.fire(this.__("forms.EvaluationChart.questions.questions_setting.question10.alert_messages.limitMax"));;
      }
      this.numberOfCourses++
      if (this.saving_settings == "save_on_training_request") {
        let params = {
          training_need_id: training_need_id,
          typology: typology,
          request: request,
          applicant_person_id: this.compiler_person_id,
          asked_for_person_id: this.owner_person_id,
        };
        axios
          .post("/training-requests" + this.userUrl, {
            trainingRequest: params,
            evaluationChart: 1,
          })
          .then((response) => {
            if (response.data === -1) {
              Vue.swal.fire({
                title: this.labels.requestAlReadyPresentTitle,
              });
              return;
            }
            this.populateRequestTable();
          });
      } else if (this.saving_settings == "save_on_evaluation_chart") {
        this.tableRequest.push({
          training_need_id: typology == "free" ? null : training_need_id,
          typology_id: typology,
          request: request,
          applicant_person_id: this.compiler_person_id,
          infoUrl: typology == "free" ? null : '/training-request-info/' + training_need_id + '/course',
        });
        saveAnswers(true);
      }
    },
    rmRequestRow(request, index) {
      let element_id = request.id;
      this.numberOfCourses--;
      if (this.saving_settings == "save_on_training_request") {
        Vue.swal
          .fire({
            title: this.labels.deleteRequestTitle,
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "OK",
          })
          .then((result) => {
            if (result.value) {
              axios
                .delete("/training-requests" + this.userUrl + "/" + element_id)
                .then((response) => {
                  this.populateRequestTable();
                });
            }
          });
      } else if (this.saving_settings == "save_on_evaluation_chart") {

        this.tableRequest.splice(index, 1);

        if (element_id != null && element_id != "") {
          this.deletedExistingTrainingRequest.push(element_id);
        }

        //wait for the html to be refreshed
        setTimeout(function () { saveAnswers(true) }.bind(this), 500);
      }
    },
    populateRequestTable() {
      //
      let params = {
        person_id: this.owner_person_id,
        question_survey_id: this.question_survey_id,
        evaluation_chart_id: this.evaluation_chart_id,
      };

      axios
        .get("/api/evaluation-chart-training-requests", {
          params,
        })
        .then((response) => {

          this.limitMin = response.data.settings.limitMin;
          this.limitMax = response.data.settings.limitMax;
          this.numberOfCourses = response.data.data.length;

          if (this.saving_settings == "save_on_training_request") {
            this.tableRequest = response.data.data != null ? response.data.data : [];
          } else {
            this.tableRequest = this.answers_question["trainingNeeds"] != null ? this.answers_question["trainingNeeds"] : [];
            this.deletedExistingTrainingRequest = this.answers_question["deletedItems"] != null ? this.answers_question["deletedItems"] : [];
          }
        });
    },
    searchAllCourses() {
      this.showLoader = true;
      let params = {
        surveyQuestion_id: this.question_survey_id,
      };
      axios
        .get("/api/learning-request-question-search-all", {
          params,
        })
        .then((response) => {
          this.tableSearch = response.data.courses;
          this.showLoader = false;
        });
    },
    searchCourses() {

      let questionSearchData = this.manageSearchingMethod();
      this.showLoader = true;
      let params = {
        questionSearchData: questionSearchData,
        surveyQuestion_id: this.question_survey_id,
      };
      axios
        .get("/api/learning-request-question-search", {
          params,
        })
        .then((response) => {
          this.showLoader = false;
          if (response.data.counter < 1) {
            //no results, ask for free request if are enabled
            if (this.free_request) {
              Vue.swal
                .fire({
                  title: this.labels.noFindRequestTitle,
                  text: this.labels.noFindRequestText,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "OK",
                })
                .then((result) => {
                  if (result.value) {
                    this.addSRequest(null, "free", this.searchBar);
                  }
                });
            } else {
              Vue.swal
                .fire({
                  title: this.labels.noFindRequestTitle,
                  icon: "warning",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "OK",
                });
            }
          }
          this.tableSearch = response.data.courses;
        });
    },
    manageSearchingMethod() {

      let field = this.advancedFilterMethod;
      let searchParam = null;

      if (['category', 'catalogCategory', 'place', 'deliveryMethod', 'trainingAgency'].includes(this.advancedFilterMethod)) {
        searchParam = this.advancedFilterDropdownSelect;
      }
      if (['begin_date', 'end_date'].includes(this.advancedFilterMethod)) {
        searchParam = this.advancedFilterDate;
      }
      if (this.advancedFilterMethod == 'duration') {
        searchParam = this.advancedFilterNumber;
      }
      if (this.advancedFilterMethod == 'keyWords') {
        searchParam = this.searchBar;
      }

      return {
        'field': field,
        'searchParam': searchParam
      }
    }
  },
};
</script>
